import * as Headless from "@headlessui/react";
import { ReactElement } from "react";

export const Dropdown = (props: Headless.MenuProps): ReactElement => (
  <Headless.Menu {...props} />
);
